import Image from '@/components/UI/Image';
import { formatLink, homeIntoDetail } from '@/utils';
import { useGlobal } from '@/utils/useGlobal';
import SwiperCore, { A11y, Autoplay, Navigation, Pagination, Scrollbar } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import css from './index.module.scss';
SwiperCore.use([Navigation, Pagination, Scrollbar, A11y]);
export default function Banner({ initData = [], router }: any) {
    const { Link, gtm } = useGlobal();
    // const homeGoDetail = (url: string) => {
    //     if (url) {
    //         router.push(url);
    //     }
    // };

    // 本地调试用
    // const gtm = {
    //     push: (obj:any) => console.log(obj)
    // }

    const { locale } = router;

    const getDataLayer = ({ position, type, banner_name }: any) => {
        const ret = {
            event: 'uaEvent',
            event_name: 'select_banner',
            banner_name,
            position,
            button_name: type,
        };
        return ret;
    };

    const getBuyDataLayer = (product_name: string) => {
        const ret = {
            event: 'uaEvent',
            event_name: 'buy',
            product_name,
            position: 'Homepage',
        };
        return ret;
    };

    const onImageClick = (params: any) => {
        const { item, position, event } = params;
        const $links: any = document.querySelectorAll('div.link a');
        if ($links.length && [...$links].every(($el) => !$el.contains(event.target))) {
            gtm.push(
                getDataLayer({
                    banner_name: `${item.mainHeading} ${item.subHeading}`,
                    position,
                    type: 'Image',
                }),
            );
        } else if (!$links.length) {
            gtm.push(
                getDataLayer({
                    banner_name: `${item.mainHeading} ${item.subHeading}`,
                    position,
                    type: 'Image',
                }),
            );
        }
    };

    const onSlideChange = (swiper: any) => {
        const $target: any = document.querySelector('.swiper-slide-active')?.querySelector('img.isInViewPort');
        if (!$target) return;
        const { bannerName = '', position = '', isReport = '0' } = $target.dataset;
        if (isReport === '1') return;
        if (!swiper?.realIndex) return;
        gtm.push({
            event: 'uaEvent',
            event_name: 'view_banner',
            banner_name: bannerName,
            position,
            nonInteraction: false,
        });
        $target.dataset.isReport = '1';
    };

    return (
        <div className={`${css.banners} banners-pc`}>
            <Swiper
                modules={[Navigation, Pagination, Autoplay]}
                navigation={true}
                width={801}
                pagination={{
                    clickable: true,
                }}
                slidesPerView={'auto'}
                initialSlide={0}
                loop={true}
                preloadImages={false}
                lazy={true}
                autoplay={false}
                onSlideChangeTransitionEnd={onSlideChange}
            >
                {initData.map((item: any, index: number) => (
                    <SwiperSlide
                        key={index}
                        onClick={(event) => {
                            onImageClick({
                                event,
                                item,
                                locale,
                                router,
                                position: `carousel banner_${index + 1}`,
                            });
                            homeIntoDetail(JSON.parse(item.buttonText)[0]?.buttonUrl, router);
                        }}
                    >
                        <div className="banner-img-box">
                            <Image
                                className="banner-img fullImgs isInViewPort"
                                src={item.webPictureUrl}
                                layout="fill"
                                alt={item.mainHeading}
                                data-banner-name={item.mainHeading}
                                data-position={`carousel banner_${index + 1}`}
                                data-is-report="0"
                            />
                        </div>

                        <div className="banner-content">
                            <div className={`banner-new ${item.lable == '' ? 'banner-new-hidden' : 'banner-new-show'}`}>{item.lable}</div>
                            <h2
                                className="banner-title font-family-bold"
                                style={{
                                    color: item.textColor === 'white' ? '#fff' : '#000',
                                }}
                            >
                                {item.mainHeading}
                            </h2>
                            <p
                                className="banner-des"
                                style={{
                                    color: item.textColor === 'white' ? '#fff' : '#000',
                                }}
                            >
                                {item.subHeading}
                            </p>
                            <div className="link">
                                {JSON.parse(item.buttonText).map(
                                    (el: { buttonUrl: string | undefined; buttonName: string | undefined }, idx: number) =>
                                        el.buttonUrl && (
                                            <Link
                                                {...formatLink(el.buttonUrl)}
                                                ariaLabel={item.mainHeading}
                                                style={{ color: item.btnColor }}
                                                className="msg-linkitem ef-icon-arrowright"
                                                key={el.buttonUrl}
                                                // 通常第一个为 Learn More, 第二个为 Buy
                                                {...(idx === 0
                                                    ? {
                                                          dataLayer: getDataLayer({
                                                              banner_name: `${item.mainHeading} ${item.subHeading}`,
                                                              position: `carousel banner_${index + 1}`,
                                                              type: 'Learn more',
                                                          }),
                                                      }
                                                    : {
                                                          dataLayer: [
                                                              getDataLayer({
                                                                  banner_name: `${item.mainHeading} ${item.subHeading}`,
                                                                  position: `carousel banner_${index + 1}`,
                                                                  type: 'Buy',
                                                              }),
                                                              getBuyDataLayer(item.mainHeading),
                                                          ],
                                                      })}
                                            >
                                                {el.buttonName}
                                            </Link>
                                        ),
                                )}
                            </div>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    );
}
